import React from 'react';
import ReactDOM from 'react-dom';
import Calculator from './Comp/Calc';

ReactDOM.render(
<>
<Calculator/>
</>,document.getElementById('root'));

